/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';

import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';

import mbpLogger from 'mbp-logger';
import ReactMarkdown from 'react-markdown';

import { getBrand } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import findContentByUID from '../../../../../gql/queries/findContentByUID';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: '20px',
        marginTop: '5px',
        maxWidth: '33%',
        [theme.breakpoints.up(1280)]: {
            paddingLeft: 0,
        },
        '& p': {
            margin: 0,
            fontFamily: theme.typography.fontFamily,
            fontSize: '12px',
            fontWeight: 600,
        },
        '& a': {
            color: '#000',
            fontWeight: 700,
        },
    },
}));

const ShippingDisclaimer = () => {
    const brand = useSelector(getBrand);
    const classes = useStyles();

    const getShippingDisclaimerDetails = {
        brand: brand['domain-name'],
        uid: 'blt125b6c38b98900a4',
        contentType: 'promo_messaging',
    };

    const SHIPPING_DISCLAIMER_QUERY = findContentByUID(getShippingDisclaimerDetails);
    const { loading, error, data } = useQuery(SHIPPING_DISCLAIMER_QUERY);

    if (loading || !data) return <></>;

    if (error) {
        mbpLogger.logError({
            query: SHIPPING_DISCLAIMER_QUERY,
            component: 'ShippingDisclaimer.js',
            message: 'Error loading shipping disclaimer info from Graphql',
            error,
        });
    }

    const disclaimer = data?.findContentByUID?.content.entry?.pdp_message;

    return (
        <div className={classes.root}>
            <ReactMarkdown source={disclaimer} escapeHtml={false} />
        </div>
    );
};

export default React.memo(ShippingDisclaimer);
